import { T, Var } from 'gt-react';
import type { McpAccessDenialReason, McpAuthorizationRequest } from '@erp/rpc';

import { Button } from 'src/components/ui/button';
import { AuthErrorMessage } from 'src/pages/(unauthenticated)/AuthErrorMessage';
import { AuthShell } from 'src/pages/(unauthenticated)/AuthShell';
import { DenialMessage } from './DenialMessage';
import { isLeaving, useDenyAuthorization } from './useConsentActions';

/** The user can't connect; they can only send the client back. */
export function ConsentDenied({
  request,
  clientName,
  reason,
}: {
  request: McpAuthorizationRequest;
  clientName: string;
  reason: McpAccessDenialReason;
}) {
  const deny = useDenyAuthorization();
  return (
    <AuthShell
      title={
        <T context="Gently MCP consent: heading when the user can't connect">
          Can't connect <Var>{clientName}</Var>
        </T>
      }
      description={<DenialMessage reason={reason} />}
    >
      <div className="flex flex-col gap-3">
        <AuthErrorMessage error={deny.error} />
        <Button
          variant="outline"
          className="w-full"
          disabled={isLeaving(deny)}
          onClick={() => deny.mutate(request)}
        >
          <T context="Gently MCP consent: decline button">Cancel</T>
        </Button>
      </div>
    </AuthShell>
  );
}
